import usePersonTypeVisibleFeatures from "./usePersonTypeVisibleFeatures";
import FeatureService from "../../Domain/Feature/Feature.service";
/**
 * Returns whether the user is able to view in line information
 *  null - visibility is loading, or there was an error loading permissions
 * true - current person can view
 * false - current person cannot view
 */
const useHasVisibility = (featureInternalNames, personTypeInternalNames) => {
    const visibleFeatures = usePersonTypeVisibleFeatures(personTypeInternalNames);
    if (!visibleFeatures.data) {
        return null;
    }
    const featureList = (() => {
        if (!featureInternalNames) {
            return [];
        }
        if (Array.isArray(featureInternalNames)) {
            return featureInternalNames;
        }
        return [featureInternalNames];
    })();
    return featureList.some((featureInternalName) => 
    // @ts-expect-error - TS2345 - Argument of type 'Feature[] | null | undefined' is not assignable to parameter of type 'Feature[]'.
    FeatureService.shouldShowFeature(featureInternalName, visibleFeatures.data));
};
export default useHasVisibility;
